import { Card } from '@foodsby/nutrient'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { ArticleLarge } from '../components/common/Layout'
import SubmitBuildingForm from '../components/location-search/SubmitBuildingForm'
import { formatFromAddressIdStart, submitBuildingStart } from '../redux/modules/locationSearch'
import { getAddressQueryStringParams } from '../redux/modules/selectors'

const SALESFORCE_URL = process.env.REACT_APP_SALESFORCE_URL || ''
let theiFrame
let form

export const NoLocationForm = ({
  city,
  error,
  state,
  street,
  submitBuildingStart,
  submitting,
  zip,
}) => (
  <div className="col-xs-12 center-xs">
    <h1 className="title">Request to Join the Foodsby Network</h1>
    <p>
      Sorry! It appears we don&apos;t currently service your office building. Fill out this form to
      get started!
    </p>
    <SubmitBuildingForm
      city={city}
      error={error}
      onSubmit={submitBuildingStart}
      state={state}
      street={street}
      submitting={submitting}
      zip={zip}
    />
  </div>
)

export const NoLocationSuccess = () => (
  <div className="col-xs-12 center-xs">
    <h1 className="title">Thanks for Requesting to Join the Foodsby Network!</h1>
    <p>A dedicated member of our team will be in touch with you soon.</p>
  </div>
)

export class PageNoLocation extends Component {
  constructor(props) {
    super(props)
    this.state = { error: false, success: false }
  }

  componentWillUnmount() {
    if (form && form.parentNode) {
      form.parentNode.removeChild(form)
    }

    if (theiFrame && theiFrame.parentNode) {
      theiFrame.parentNode.removeChild(theiFrame)
    }
  }

  submitForm = values => {
    const customHiddenIframeName = 'JLA_API'
    if (!document.getElementById(customHiddenIframeName)) {
      theiFrame = document.createElement('iframe')
      theiFrame.id = customHiddenIframeName
      theiFrame.name = customHiddenIframeName
      theiFrame.src = 'about:blank'
      theiFrame.style.display = 'none'
      document.body.appendChild(theiFrame)
      values['retURL'] = 'http://127.0.0.1' // dummy URL
      form = document.createElement('form')
      form.method = 'POST'
      form.action = SALESFORCE_URL
      form.setAttribute('target', customHiddenIframeName)
      Object.keys(values).forEach(value => {
        const theInput = document.createElement('input')
        theInput.name = value
        theInput.value = values[value]
        theInput.setAttribute('type', 'hidden')
        form.appendChild(theInput)
      })
      document.body.appendChild(form)
      form.submit()
      this.setState({ success: true })
    }
  }
  render() {
    const { submitting, address = {} } = this.props
    const { error, success } = this.state

    return (
      <ArticleLarge>
        <Card>
          <div className="row">
            {success ? (
              <NoLocationSuccess />
            ) : (
              <NoLocationForm
                city={address.city}
                error={error}
                state={address.state}
                street={address.street}
                submitBuildingStart={this.submitForm}
                submitting={submitting}
                zip={address.zip}
              />
            )}
          </div>
        </Card>
      </ArticleLarge>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { submitting } = state.locationSearch
  return {
    address: getAddressQueryStringParams(state, ownProps),
    submitting,
  }
}

const mapDispatchToProps = {
  formatFromAddressIdStart,
  submitBuildingStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageNoLocation)
